import { createColumnHelper } from '@tanstack/react-table';

import { NamespaceAccess } from '../../types';

export const helper = createColumnHelper<NamespaceAccess>();
